import { SummaryTable } from '../SummaryTable.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.js';
import { CostApproachSummaryDepreciatedCostRow } from './CostApproachSummaryDepreciatedCostRow.js';
import { CostApproachSummaryDepreciationRows } from './CostApproachSummaryDepreciationRows.js';
import { CostApproachSummaryIndicatedValue } from './CostApproachSummaryIndicatedValue.js';
import { CostApproachSummaryRow } from './CostApproachSummaryRow.js';
import { CostApproachSummarySiteValueRow } from './CostApproachSummarySiteValueRow.js';
import { CostApproachSummaryTableHeader } from './CostApproachSummaryTableHeader.js';
import { CostApproachSummaryTotalCostNew } from './CostApproachSummaryTotalCostNew.js';

export const CostApproachSummaryTable = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const subject = props.results.subject;
  return (
    <SummaryTable {...props}>
      <CostApproachSummaryTableHeader />
      <CostApproachSummarySiteValueRow siteValue={subject?.totals?.costApproach?.site} {...props} />
      <CostApproachSummaryRow
        label="Dwelling"
        row={subject?.totals?.costApproach?.dwelling}
        {...props}
      />
      <CostApproachSummaryRow
        label="Basement"
        row={subject?.totals?.costApproach?.basement}
        {...props}
      />
      <CostApproachSummaryRow
        label="Additional Structures"
        row={subject?.totals?.costApproach?.additionalStructures}
        {...props}
      />
      <CostApproachSummaryRow
        label="Garage/Carport"
        row={subject?.totals?.costApproach?.garageCarport}
        {...props}
      />
      <CostApproachSummaryTotalCostNew
        totalEstimatedCostNew={subject?.totals?.improvements.new.cost}
        {...props}
      />
      <CostApproachSummaryDepreciationRows
        depreciation={subject?.totals?.costApproach?.depreciation}
        {...props}
      />
      <CostApproachSummaryDepreciatedCostRow
        cost={subject?.totals?.improvements.depreciated.cost}
        {...props}
      />
      <CostApproachSummaryIndicatedValue
        indicatedValue={subject?.totals?.costApproach?.indicatedValue}
        {...props}
      />
    </SummaryTable>
  );
};
